import { render, staticRenderFns } from "./LayoutEmpty.vue?vue&type=template&id=15431cd6&scoped=true&"
import script from "./LayoutEmpty.vue?vue&type=script&lang=js&"
export * from "./LayoutEmpty.vue?vue&type=script&lang=js&"
import style0 from "./LayoutEmpty.vue?vue&type=style&index=0&id=15431cd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15431cd6",
  null
  
)

export default component.exports